import { render, staticRenderFns } from "./InventoryPendingArrivalPod.vue?vue&type=template&id=4a8e01d4&scoped=true"
import script from "./InventoryPendingArrivalPod.vue?vue&type=script&lang=js"
export * from "./InventoryPendingArrivalPod.vue?vue&type=script&lang=js"
import "./InventoryPendingArrivalPod.vue?vue&type=style&index=0&id=4a8e01d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8e01d4",
  null
  
)

export default component.exports